import React, { useState } from "react";
import styles from "./skill.module.css";
import { LOCALES, SKILL_TARGET_TYPE, SKILL_TYPE, UI_TEXT } from "../../../../constants";
import { v4 } from "uuid";
import {
    getFactorTag,
    getFactorText,
    getNovaBuffTag,
    getSkillDescWithFlavorTexts,
    replaceColorTag,
} from "../../../../functions/stringFunctions";
import getImageFileName from "../../../../functions/getImageFileName";
import { getUIText } from "../../../../translation";

export default function Skill({ lang, charName, skill, isBlossomed = false }) {
    const [isActive, setIsActive] = useState(false);

    const descObj = getSkillDescWithFlavorTexts(lang, skill.levels.at(-1).skill_desc);
    return (
        <div className={styles["skill"]}>
            <div className={styles["skill-header"]}>
                <img
                    src={`${process.env.PUBLIC_URL}/images/icon/skills/${charName}_${isBlossomed ? "blossom_" : ""}${SKILL_TYPE[skill.type][LOCALES.KO]}.webp`}
                />
                <div className={styles["skill-summary"]}>
                    <div className={styles["name-wrapper"]}>
                        <span className={styles["skill-name"]}>{skill.name[lang]}</span>
                        <span className={styles["skill-type"]}>{SKILL_TYPE[skill.type][lang]}</span>
                    </div>
                    {((skill.cooltime || skill.target || skill.break || skill.nova) && (
                        <div className={styles["badges"]}>
                            {skill.cooltime !== 0 && (
                                <span className={`${styles["badge"]} ${styles["cooltime"]}`}>
                                    {skill.cooltime}
                                    &nbsp;{getUIText(lang, "savior.modal.skills.badge.turn")}
                                </span>
                            )}
                            {skill.target !== "NSTT_INVALID" && skill.target.includes("ENEMY") && (
                                <span className={`${styles["badge"]} ${styles["target"]}`}>{SKILL_TARGET_TYPE[skill.target][lang]}</span>
                            )}
                            {skill.target !== "NSTT_INVALID" && !skill.target.includes("ENEMY") && (
                                <span className={`${styles["badge"]} ${styles["target-ally"]}`}>
                                    {SKILL_TARGET_TYPE[skill.target][lang]}
                                </span>
                            )}
                            {skill.break !== 0 && (
                                <span className={`${styles["badge"]} ${styles["break"]}`}>
                                    {getUIText(lang, "savior.modal.skills.badge.toughness")} {skill.break}
                                </span>
                            )}
                            {skill.nova !== 0 && (
                                <span className={`${styles["badge"]} ${styles["nova-gain"]}`}>
                                    {getUIText(lang, "savior.modal.skills.badge.nova")} {skill.nova}
                                </span>
                            )}
                        </div>
                    )) || (
                        <div className={styles["badges"]}>
                            <span className={`${styles["badge"]} ${styles["blank"]}`}> </span>
                        </div>
                    )}
                </div>
            </div>
            <div className={styles["skill-desc-wrapper"]}>
                <div className={styles["skill-desc"]} dangerouslySetInnerHTML={{ __html: descObj.desc }}></div>
                <div className={styles["skill-desc"]} dangerouslySetInnerHTML={{ __html: getFactorTag(lang, skill) }}></div>
                {descObj.buffList.length > 0 && (
                    <div className={styles["flavor-texts"]}>
                        {descObj.buffList.map((buff) => {
                            return (
                                <div key={v4()}>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/icon/buff/${getImageFileName(buff.name[LOCALES.KO])}.webp`}
                                    />
                                    &nbsp;
                                    <span className={styles["buff-name"]}>{buff.name[lang]}</span>&nbsp;:&nbsp;
                                    <span>{buff.desc[lang]}</span>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            {skill.type !== 0 && skill.nova_desc["ko-KR"] !== "구원자" && (
                <div className={styles["skill-nova"]}>
                    <span className={`${styles["badge"]} ${styles["nova"]}`}>{getUIText(lang, "savior.modal.skills.nova.title")}</span>
                    <span className={styles["desc"]} dangerouslySetInnerHTML={{ __html: replaceColorTag(skill.nova_desc[lang]) }}></span>
                    <span className={styles["desc"]} dangerouslySetInnerHTML={{ __html: getNovaBuffTag(lang, skill) }}></span>
                </div>
            )}
            <div className={`${styles["level-data-wrapper"]} ${isActive ? `${styles["active"]}` : ""} `}>
                <button className={styles["show-level-button"]} onClick={() => setIsActive(!isActive)}>
                    {getUIText(lang, "savior.modal.skills.levels.title")} <span className={styles["triangle"]}>▼</span>
                </button>
                <div className={styles["level-data"]}>
                    {skill.levels.map((level_info) => {
                        if (skill.type === 0) {
                            // passive
                            return (
                                <div className={styles["row"]} key={v4()}>
                                    <span className={styles["level"]}>{level_info.level}</span>
                                    <span
                                        className={styles["value"]}
                                        dangerouslySetInnerHTML={{ __html: replaceColorTag(level_info.skill_desc[lang]) }}
                                    ></span>
                                </div>
                            );
                        } else {
                            // active
                            return (
                                <div className={styles["row"]} key={v4()}>
                                    <span className={styles["level"]}>{level_info.level}</span>
                                    <span className={styles["value"]}>{level_info.level_desc[lang]}</span>
                                </div>
                            );
                        }
                    })}
                </div>
            </div>
        </div>
    );
}
